<template>
    <v-sheet class="fill-height d-flex flex-column">
        <v-card-text>
            <v-expansion-panels flat mandatory>
                <template v-for="side in sides">
                    <side-list v-model="form" v-bind="{ side }" :key="side" />
                </template>
            </v-expansion-panels>
            <side-file v-model="form" @input="emit" class="mt-16" />
        </v-card-text>
    </v-sheet>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentForm } from "@/assets/variables";

import SideFile from "./side/side-file.vue";
import SideList from "./side/side-list.vue";

const sides = Object.keys(EMPLOYMENT_FIELD_SIDES);

export default {
    components: {
        SideFile,
        SideList,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),
        sides,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
